
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface NavbarMenuProps {
  closeMenu?: () => void;
  isMobile?: boolean;
}

const NavbarMenu: React.FC<NavbarMenuProps> = ({ closeMenu, isMobile = false }) => {
  const location = useLocation();
  const { t } = useTranslation();

  // Array of navigation items with direct page paths
  const navItems = [
    { name: t("nav.howItWorks"), path: "/how-it-works" },
    { name: t("nav.properties"), path: "/properties" },
    { name: t("nav.proptalk"), path: "/proptalk" },
    { name: "Blog", path: "/blog" },
    { name: t("nav.about"), path: "/about" },
    { name: "CEO", path: "/ceo" },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  if (isMobile) {
    return (
      <nav className="flex flex-col space-y-1">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            onClick={() => {
              if (closeMenu) closeMenu();
            }}
            className={cn(
              "py-3 px-4 text-lg font-medium rounded-lg transition-colors touch-target-lg active:bg-white/10 text-left",
              isActive(item.path)
                ? "bg-white/10 text-white"
                : "text-white/80 hover:bg-white/5 hover:text-white"
            )}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    );
  }

  return (
    <nav className="hidden md:flex md:items-center md:space-x-1">
      {navItems.map((item) => (
        <Link
          key={item.name}
          to={item.path}
          className={cn(
            "px-3 py-2 text-sm font-medium rounded-md transition-colors",
            isActive(item.path)
              ? "text-propmatch-blue"
              : "text-white/90 hover:text-white hover:bg-white/5"
          )}
        >
          {item.name}
        </Link>
      ))}
    </nav>
  );
};

export default NavbarMenu;
